import { render } from "./empty-header.vue?vue&type=template&id=a7367dc4&scoped=true&ts=true"
import script from "./empty-header.vue?vue&type=script&lang=ts"
export * from "./empty-header.vue?vue&type=script&lang=ts"

import "./empty-header.vue?vue&type=style&index=0&id=a7367dc4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7367dc4"]])

export default __exports__